/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box } from "@mui/material";
import { DataGrid, GridColDef, GridClasses } from "@mui/x-data-grid";
import { Tooltip, IconButton } from "@mui/material";
import { AiOutlineFileSearch } from "react-icons/ai";
import { MdOutlineContentCopy } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

type RowData = {
  id: string;
  suba_name: string;
};

const ReceiverAccountList: React.FC<{
  isLoading: boolean;
  page: number;
  pageSize: number;
  rowCount: number;
  tableData: RowData[];
  setPaginationModel: any;
  currentLastKey: string;
  entityType?: string;
}> = ({
  isLoading,
  page,
  pageSize,
  rowCount,
  tableData,
  setPaginationModel,
  currentLastKey,
  entityType,
}) => {
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole")?.toLowerCase();

  const handleClickCopy = async (id: string) => {
    try {
      await navigator.clipboard.writeText(id);
    } catch (err) {
      console.error("Failed to copy ID: ", err);
    }
  };

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "",
      flex: 1,
      minWidth: 50,
      maxWidth: 50,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Tooltip title="Copy ID" arrow placement="top">
          <div>
            <IconButton
              id={"button-copy-id-" + params?.row?.id}
              onClick={() => handleClickCopy(params.row.id)}
            >
              <MdOutlineContentCopy className="h-5 w-5 text-navy-700" />
            </IconButton>
          </div>
        </Tooltip>
      ),
    },
    {
      field: "suba_name",
      headerName: entityType === "AGNT#" ? "Agent" : "Subaccount",
      minWidth: 150,
      sortable: false,
      flex: 1,
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      flex: 1,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => {
        return (
          <Tooltip title="View More Details" arrow placement="right">
            <div className="mr-5">
              <IconButton
                id={"button-detail-" + params?.row?.id}
                onClick={() => handleClickDetail(params.row.id)}
              >
                <AiOutlineFileSearch className="h-5 w-5 text-navy-700" />
              </IconButton>
            </div>
          </Tooltip>
        );
      },
    },
  ];

  const handleClickCreate = () => {
    navigate(`/${userRole}/merchants/subaccounts/create`);
  };

  const handleClickDetail = (id: any) => {
    if (entityType === "AGNT#") {
      navigate(`/${userRole}/agents/${id}`);
    } else {
      navigate(`/${userRole}/merchants/subaccounts/${id}`);
    }
  };

  const customDataGridStyles: Partial<GridClasses> = {
    root: "mui-table-custom",
    columnHeader: "text-start",
    row: "",
  };

  const handleClickDetails = (id: any) => {};

  return (
    <div className="px-4 py-8">
      <Box>
        <DataGrid
          sx={{
            "& .MuiDataGrid-cell": {
              padding: "8px 16px",
            },
            "& .MuiDataGrid-columnHeader": {
              padding: "8px 16px",
            },
            "& .MuiTablePagination-input": {
              marginRight: "-20px",
            },
            "& .MuiTablePagination-displayedRows": {
              display: "none",
            },
          }}
          loading={isLoading}
          rows={tableData || []}
          columns={columns}
          getRowId={(row) => row.id}
          rowCount={rowCount}
          sortingMode="server"
          paginationMode="server"
          pageSizeOptions={[10, 25, 50, 100]}
          rowHeight={40}
          columnHeaderHeight={40}
          paginationModel={{ page: page, pageSize: pageSize }}
          onPaginationModelChange={(newValue) => setPaginationModel(newValue)}
          disableRowSelectionOnClick
          disableColumnFilter
          disableColumnMenu
          classes={customDataGridStyles}
          hideFooter={currentLastKey === "" && page === 0}
          autoHeight
          localeText={{
            noRowsLabel: "No data available",
          }}
        />
      </Box>
    </div>
  );
};

export default ReceiverAccountList;
